module.exports = __webpack_public_path__ + "img/icon.c7e622c6.png";